// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"11001":"2357fd6fa798c691","22682":"cce98443f6ddd1b7","37125":"50fa1c9fb7f13152"}[chunkId] + ".css";
};